var _defs, _path, _path2, _path3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-1{stroke:#1e2341;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2,.cls-3{stroke:#f0f5ff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dark light button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85,100a15,15,0,1,0,15-15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.43,76.9C95.82,74.67,100,65,100,65s4.2,9.68,9.57,11.9,15.18-1.65,15.18-1.65-3.9,9.75-1.65,15.18S135,100,135,100s-9.65,4.12-11.9,9.57,1.65,15.18,1.65,15.18-9.79-3.88-15.18-1.65S100,135,100,135s-4.2-9.68-9.57-11.9-15.18,1.65-15.18,1.65,3.84-9.91,1.65-15.18S65,100,65,100s9.69-4.23,11.9-9.57-1.65-15.18-1.65-15.18S85,79.14,90.43,76.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190,220a30,30,0,0,1,38.71-28.71,30,30,0,1,0-37.42,37.42A30,30,0,0,1,190,220Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 217,
    y1: 227,
    x2: 217,
    y2: 211
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212,
    y1: 219,
    x2: 222,
    y2: 219
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightDarkMode);
export default __webpack_public_path__ + "static/media/light_dark_mode.5ded44a6a2db681d4a842a3c6423a45c.svg";
export { ForwardRef as ReactComponent };